/** The `ceremonies` area: ceremonies. Owned by the stage 2 slot flows
 *  (docs/I18N.md §11). The keys read in page order: the index and the convene
 *  form, then one ceremony's review: its head, participants, the add-decision
 *  form and the agenda. */
export const ceremonies = {
  // --- The Ceremonies index ---
  'ceremonies.index.title': 'Ceremonies',
  /** The sub-line under the title with no ceremony yet. */
  'ceremonies.index.sub': 'decision bundles',
  'ceremonies.index.openOf': '{open} open of {count}',
  'ceremonies.index.empty':
    'No ceremonies yet. Convene one to bundle decisions - advances, holds, acceptances - and work them together in a review.',
  /** A row's counts: agenda items, and how many still wait. */
  'ceremonies.index.items': { one: '{count} item', other: '{count} items' },
  'ceremonies.index.itemsPending': {
    one: '{count} item · {pending} pending',
    other: '{count} items · {pending} pending',
  },
  /** A ceremony's status badge. */
  'ceremonies.status.open': 'open',
  'ceremonies.status.closed': 'closed',
  /** An act that never reached the server. */
  'ceremonies.unreached': 'The action failed to reach the server. Reload and try again.',
  // --- Convene ---
  'ceremonies.convene.placeholder': 'Convene a ceremony…',
  'ceremonies.convene.title': 'Ceremony title',
  'ceremonies.convene.submit': 'Convene',
  // --- A ceremony's review: the head ---
  'ceremonies.review.convenedBy': 'Convened by {name}',
  'ceremonies.review.close': 'Close ceremony',
  'ceremonies.review.somethingWrong': 'Something went wrong.',
  // --- Participants ---
  'ceremonies.participants.title': 'Participants',
  'ceremonies.participants.empty': 'No one on the roster yet.',
  /** A meeting role in the role select. */
  'ceremonies.role.facilitator': 'Facilitator',
  'ceremonies.role.decider': 'Decider',
  'ceremonies.role.contributor': 'Contributor',
  'ceremonies.role.observer': 'Observer',
  /** A meeting role on a closed ceremony's roster. */
  'ceremonies.roleChip.facilitator': 'facilitator',
  'ceremonies.roleChip.decider': 'decider',
  'ceremonies.roleChip.contributor': 'contributor',
  'ceremonies.roleChip.observer': 'observer',
  'ceremonies.participants.roleFor': 'Role for {name}',
  'ceremonies.participants.remove': 'Remove',
  'ceremonies.participants.suggested': 'Suggested deciders:',
  'ceremonies.participants.add': 'Add a participant',
  'ceremonies.participants.addPlaceholder': 'Add a person or group…',
  'ceremonies.participants.role': 'Role',
  'ceremonies.participants.addSubmit': 'Add',
  // --- Add a decision ---
  /** The decisions the form offers for the picked item. */
  'ceremonies.choice.accept': 'Accept',
  'ceremonies.choice.dispute': 'Deny',
  'ceremonies.choice.resolve': 'Resolve (reopen verdict)',
  'ceremonies.choice.advance': 'Advance to {stage} · {flow}',
  'ceremonies.choice.hold': 'Hold · {flow}',
  'ceremonies.decision.search': 'Add a decision: search an item…',
  'ceremonies.decision.searchLabel': 'Search an item to decide',
  'ceremonies.decision.name': 'Name this decision (optional)…',
  'ceremonies.decision.nameLabel': 'Decision name',
  'ceremonies.decision.choiceLabel': 'Decision to stage',
  'ceremonies.decision.choice': 'Choose a decision…',
  'ceremonies.decision.removeDecider': 'Remove decider',
  'ceremonies.decision.addDecider': 'Add a decider',
  'ceremonies.decision.addDeciderPlaceholder': '+ decider',
  'ceremonies.decision.reason': 'Reason (optional)…',
  'ceremonies.decision.reasonLabel': 'Reason',
  'ceremonies.decision.add': 'Add',
  'ceremonies.decision.cancel': 'Cancel',
  // --- The agenda ---
  'ceremonies.agenda.empty':
    "No decisions on the agenda yet. Search an item above to add one, or queue an advance or hold from an item's flow strip.",
  /** A decision's outcome on the agenda. */
  'ceremonies.outcome.advance': 'Advance',
  'ceremonies.outcome.hold': 'Hold',
  'ceremonies.outcome.accept': 'Accept',
  'ceremonies.outcome.dispute': 'Deny',
  'ceremonies.outcome.resolve': 'Resolve',
  /** Stands in for the title of a subject the viewer may not see. */
  'ceremonies.agenda.restricted': 'restricted item',
  'ceremonies.agenda.take': 'Take',
  'ceremonies.agenda.decline': 'Decline',
  /** A worked decision's status. */
  'ceremonies.itemStatus.pending': 'pending',
  'ceremonies.itemStatus.applied': 'applied',
  'ceremonies.itemStatus.declined': 'declined',
} as const;
